export const environment = {
	shopname: 'Gi.Metal',
	shopdescription: 'Gi.Metal',
	production: true,
	analytics: undefined,
	theme: 'tools',
	collectionlayout: 'leftsidebar',
	collectionpagesize: 16,
	productlayout: 'leftsidebar',
	themecolor: '#005bac',
	logo: 'gimetal-logo.png',
	shopcover: 'gimetal-logo.png',
	b2b: false,
	maxprice: 200,
	showpricefilter: false,
	storecode: 'devgimetal',
	leftmenu: true,
	defaultlang: 'it',
	showvat: true,
	invoicemode: 'always',// bytype / always / optional
	billingtypes: { 0: true, 1: true, 2: false }, //0 : individual, 1: company, 2: association
	defaultcountry: 'Italia',
	onlydefaultcountry: false,
	completenewsletter: true,
	shopURL: 'https://demo.gimetal.it',
	baseURL: 'https://demo.gimetal.it',
	topbartext: 'Welcome to Gi.Metal Dashboard - Tel. +39 0573 1943680',
	copyright: 'Gi.Metal srl - Via Croce Rossa, 1/C - 51037 Montale (PT), Italia - p.i. 01888690979 ',
	analyticsdebug: true,
	ing4url: undefined,
	showdocuments: true,
	baseProductURL: '/shop/product/',
	loginredirecturl: '/user/signin',
	wishlistURL: 'https://demo.gimetal.it/shop/wishlist',
	customsections: [],
	registerRedirectUrl: '/signup',
	forgotpasswordredirecturl: '/forgot-password',
	showMobilePrefix: true,
	apiprefix: '/ws/',
	externalapi: '/ws/',
	runisolated: false,
	caneditbillingaddress: false,

	dashboard: 'summary'
};
